import DOMPurify from "dompurify";

const domPurify = (props) => {
  let output = "";
  if (typeof window !== "undefined") {
    output = DOMPurify?.sanitize(props);
  } else {
    const jsdom = require("jsdom");
    output = DOMPurify(new jsdom.JSDOM("").window)?.sanitize(props);
  }
  return { __html: output };
};

export default domPurify;
